import TopupWithdrawView from 'src/sections/overview/topup-withdraw/view/topup-withdraw-view';

export default function TopupWithdraw() {
  return <TopupWithdrawView />;
}
